import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot from react-dom/client
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// Get the root element
const container = document.getElementById('root');

// Create a root
const root = createRoot(container);

// reCAPTCHA v3 site key
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

// Initial render
root.render(
    <Provider store={store}>
        <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
            <App />
        </GoogleReCaptchaProvider>
    </Provider>
);
